import Cookies from "js-cookie";
import moment from "moment";
import { useEffect, useState } from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { ChevronRight, Edit, Info, PlusCircle, Trash2 } from "react-feather";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
    CollectStore,
    DeliveryTruck,
    DepositIcon,
    Effect,
} from "../../assets/svgIcon/customIcon";
import { productDetailsClient } from "../../data/product-details";
import { NotFound } from "../../pages";
import {
    deleteCookie,
    getAuthCredentials,
    QUOTE_SESSION,
    setIdvBypass,
    setQuoteCookies,
} from "../../utils/auth-utils";
import { calculateDuration, isSameDate } from "../../utils/utils";
import CalendarModal from "../calendarModal/calendarModal";
import Button from "../command/Button/Button";
import { FormattedDateRange } from "../command/dateTime/formatDateRange";
import { DateTimeDisplay } from "../command/dateTime/formatDateTime";
import LoaderPage from "../command/loader/loader";
import NotificationModal from "../command/notificationModal/notificationModal";
import SiteCookiesModal from "../command/siteCookiesModal/siteCookiesModal";
import "./productCart.scss";
import { useAuth } from "../../contexts/authContext";

interface ProductRate {
    productUuid: string;
    productVariantUuid: string;
    productName: string;
    option1?: string;
    option2?: string;
    option3?: string;
    rentalTerm: string;
    quantity: number;
    productRate: number;
    productDepositAmount: number;
    productRentalValue: number;
    productRetailValue: number;
    isAddOn: boolean;
    isProductAvailable?: boolean;
    updateQuoteProduct?: boolean;
}

interface QuoteChargesResponse {
    orderValue: number;
    depositCharge: number;
    serviceCharge: number;
    deliveryCharge: number;
    instoreCollectionCharge: number;
    productRates: ProductRate[];
    productInStoreCollection: boolean;
    productDelivery: boolean;
    productAvailibility: boolean;
    updateQuoteProduct?: boolean;
}

interface CreateQuoteResponse {
    quote: {
        uuid: string;
    };
}

interface charges {
    deliveryCharge: number;
    instoreCollectionCharge: number;
    depositCharge: number;
    serviceCharge: number;
}

interface OwnItPricing {
    discountPercentage: number;
    purchasePrice: number;
    // Add other ownItPricing properties if needed
}

interface quote {
    orderAmount: number;
    serviceCharge: number;
    deliveryCharge: number;
    totalDepositAmount: number;
    deliveryMethod: string;
    deliveryAndCollectionCharge: number;
    instoreCollectionCharge: number;
    rentalStartDate: any;
    rentalEndDate: any;
    rentalType: any;
    retailerUuid: any;
    storeUuid: any;
    rentalDuration: any;
    canConvertedToPurchaseAfterRent?: boolean;
    ownItPricing?: OwnItPricing;
    discountCode?: string;
    discountAmount?: number;
    totalQuoteValue?: any;
    showAddDiscountButton?: boolean;
}

const ProductCart = () => {
    const navigate = useNavigate();
    const [deliveryMethod, setDeliveryMethod] = useState("");
    const [modalShow, setModalShow] = useState(false);
    const [productDelete, setProductDelete] = useState(false);
    const [data, setData] = useState<any>([]);
    const [productData, setProductData] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [editingProduct, setEditingProduct] = useState();
    const [deletProductId, setDeletProductId] = useState<string>("");
    const [deleteVariantId, setDeleteVariantId] = useState<string>("");
    const [quoteCharges, setQuoteCharges] = useState<any>(null); // quoteChargesForDisplay...2 row for 2 quantity...so spread it in array before updating
    const [quoteChargesForProceed, setQuoteChargesForProceed] = useState<any>(null);
    const [quote, setQuote] = useState<quote>();
    const [productPricing, setProductPricing] = useState<any>(null);
    const [commonProductPricing, setCommonProductPricing] = useState<any>(null);
    const [totalAmount, setTotalAmount] = useState<any>(0);
    const [totalWithoutDeposite, setTotalWithoutDeposite] = useState<any>(0);
    const [searchParams, setSearchParams] = useSearchParams();
    const quoteUuidFromUrl = searchParams.get("quoteUuid");
    const { customerUuid, quoteId: quoteIdFromCookie } = getAuthCredentials();
    const quoteId = quoteIdFromCookie ?? quoteUuidFromUrl ?? null;
    const [cookiesConsent, setCookiesConsent] = useState(Cookies.get("cookiesConsent"));
    const [cookiesModalShow, setCookiesModalShow] = useState(false);
    const [hideCollectFromStore, setHideCollectFromStore] = useState(false);
    const [storeDetails, setStoreDetails] = useState<any>(null);
    const [productDetailsByUUID, setProductDetailsByUUID] = useState<any>(null);
    const { t } = useTranslation();
    const productUuid = localStorage.getItem("productUuid");
    const productVariantUuid = localStorage.getItem("productVariantUuid");
    const [bookingDateStr, setBookingDateStr] = useState<any>();
    const { baseProductUuidForAddOn, setBaseProductUuidForAddOn } = useAuth();
    const [showPromocode, setShowPromocode] = useState(false);
    const [promocodeInput, setPromocodeInput] = useState("");
    const [appliedPromocode, setAppliedPromocode] = useState<string | null>(null);
    const [discountError, setDiscountError] = useState(false);
    const [isApplyingPromocode, setIsApplyingPromocode] = useState(false);
    const [lastAttemptedPromocode, setLastAttemptedPromocode] = useState("");
    const [openDiscountSection, setOpenDiscountSection] = useState(false);


    useEffect(() => {
        let parsedDate = null;
        try {
            const storedValue = localStorage.getItem("bookingDate");
            parsedDate = storedValue ? JSON.parse(storedValue) : null;
        } catch (error) {
            console.error("Error parsing booking date:", error);
        }
        setBookingDateStr(parsedDate);
    }, []);
    useEffect(() => {
        if (!cookiesConsent) {
            setCookiesModalShow(true);
        } else if (cookiesConsent === "rejected") {
            setCookiesModalShow(true);
        }
    }, [cookiesConsent]);

    const handleCookieConsent = (consent: string) => {
        Cookies.set("cookiesConsent", consent, { expires: 365 });
        setCookiesConsent(consent);
        setCookiesModalShow(false);
    };

    useEffect(() => {
        if (!quoteIdFromCookie && quoteUuidFromUrl && cookiesConsent === "isAccepted") {
            setQuoteCookies(quoteUuidFromUrl);
            setSearchParams({}, { replace: true });
        }
    }, [quoteIdFromCookie, quoteUuidFromUrl, cookiesConsent]);

    useEffect(() => {
        if (!quoteId) {
            if (productUuid) {
                navigate(`/product/?id=${productUuid}`);
            } else {
                navigate(`/not-found`);
            }
        }
    }, [quoteId, productUuid]);

    useEffect(() => {
        if (productUuid != null && productUuid) {
            localStorage.setItem("productUuid", productUuid);
            productDetailsClient
                .getProductDetails({ productUuid: productUuid })
                .then((data: any) => {
                    localStorage.setItem("storeUuid", data.storeDetails.uuid);
                    setIdvBypass(data.storeDetails);
                    setStoreDetails(data.storeDetails);
                    setProductDetailsByUUID(data.product);
                    setProductPricing(data.productPricing);
                    setLoading(false);
                })
                .catch((error) => {
                    setError(error.message);
                    setLoading(false);
                });
        }
    }, [productUuid]);

    const calculateProductsInCart = (products: any) => {

        let cartQuantity: any = "";

        if (products && products.length > 0) {
            cartQuantity = products.reduce((sum: any, item: any) => sum + item.productQuantity, 0);
        }

        return cartQuantity;
    }

    // Filter out product pricing with 0 or null values
    const filterProductPrice = (product: any) => {
        if (!product.productPricing) return []; // Return unchanged if no productPricing

        const cleanedPricing = Object.fromEntries(
            Object.entries(product.productPricing).filter(([key, value]) => value !== 0 && value !== null)
        );

        return cleanedPricing;
    };

    // Booking dates from the quote API are wall-clock time serialized with a "Z" suffix
    // (see getLocalDate in calendarModal.tsx). This reverses that so moment()-based
    // display components show the intended hour/minute instead of shifting by the
    // browser's timezone offset.
    const floatingUtcToLocalDate = (isoString: string) => {
        const parsed = new Date(isoString);
        return new Date(
            parsed.getUTCFullYear(),
            parsed.getUTCMonth(),
            parsed.getUTCDate(),
            parsed.getUTCHours(),
            parsed.getUTCMinutes(),
            parsed.getUTCSeconds()
        );
    };

    const getQuoteData = async (fromPromocode?: boolean) => {
        !fromPromocode && setLoading(true);
        setDeliveryMethod("");
        await productDetailsClient
            .getProductDetailsList({ quoteUuid: quoteId })
            .then(async (data: any) => {
                if (data.quote.isDeleted) {
                    toast.error("Something went wrong");
                    setLoading(false);
                } else {
                    !fromPromocode && setLoading(true);


                    const newProductList = data?.products.map(
                        (productData: any) => {
                            return {
                                productUuid: productData.productUuid,
                                productName: productData.productName,
                                retailerUuid: productData?.retailerUuid,
                                storeUuid: productData?.storeUuid,
                                rentalDuration: productData?.rentalTerm, // rental duration,
                                quantity: productData?.productQuantity,
                                rentalType: data?.quote?.rentalType,
                                bookingDate: {
                                    bookingStartDate:
                                        productData?.productBookingStartDate,
                                    bookingEndDate:
                                        productData?.productBookingEndDate,
                                },
                                uuid: productData.uuid,
                                productVariantUuid: productData?.productVariantUuid,
                                option1: productData?.option1,
                                option2: productData?.option2,
                                option3: productData?.option3,
                                productRentalValue: productData?.productRentalValue,
                                productRetailValue: productData?.productRetailValue,
                                isAddOn: data?.products.find((row: any) => row.productVariantUuid === productData?.productVariantUuid)?.isAddOn ?? false,
                                baseProductUuidForAddOn: data?.products.find((row: any) => row.isAddOn === false)?.productUuid ?? productData.productUuid,
                                ...quoteId && { previousQuoteUuid: quoteId },
                            };
                        }
                    );

                    // setProductData(newProductList);
                    await productDetailsClient
                        .getQuotesCharges({ products: newProductList })
                        .then(async (response: any) => {
                            setLoading(false);

                            const responseWithQuantity = {
                                ...response,
                                productRates: response.productRates.map((productRate: any) => {
                                    const matchingProduct = newProductList.find(
                                        (newProduct: any) => newProduct.productUuid === productRate.productUuid &&
                                            newProduct.productVariantUuid === productRate.productVariantUuid
                                    );

                                    const quantity = matchingProduct ? matchingProduct.quantity || 1 : 1;

                                    // Return a single product rate with the quantity included
                                    return {
                                        ...productRate,
                                        quantity: quantity
                                    };
                                }),
                            };

                            const filteredProductPricing = response.productRates.map(filterProductPrice);

                            const commonKeys = filteredProductPricing
                                .map((obj: any) => Object.keys(obj)) // Get all keys of each object
                                .reduce((acc: any, keys: any) => acc.filter((key: any) => keys.includes(key)), Object.keys(filteredProductPricing[0])); // Find common keys

                            setCommonProductPricing(commonKeys);

                            setQuoteCharges(responseWithQuantity);
                            setQuoteChargesForProceed(response);
                            setProductData(responseWithQuantity?.productRates);
                            if (response?.productInStoreCollection) {
                                setDeliveryMethod("Collect in Store");
                                setHideCollectFromStore(false);
                            } else if (response?.productDelivery) {
                                setHideCollectFromStore(true);
                                setDeliveryMethod("Delivery and Collection");
                            } else {
                                setHideCollectFromStore(true);
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            toast.error(error?.message);
                        });
                    const productArray = data?.products.map((row: any) => {
                        return {
                            ...row,
                            productBookingEndDate: data?.quote.rentalType === 'daily' && !isSameDate(
                                row?.productBookingStartDate,
                                row?.productBookingEndDate)
                                ? moment(row?.productBookingStartDate)
                                    .add(parseInt(row.rentalTerm) - 1, 'days')
                                : row.productBookingEndDate
                        }
                    });
                    setData(productArray);
                    setQuote(data?.quote);
                    // if (data?.quote?.discountCode) {
                    setAppliedPromocode(data.quote.discountCode);
                    // }
                    if (data.products.length > 0) {
                        if (!baseProductUuidForAddOn) {
                            setBaseProductUuidForAddOn(data?.products.find((row: any) => row.isAddOn === false)?.productUuid ?? productData.productUuid)
                        }

                        localStorage.setItem(
                            "card-item",
                            calculateProductsInCart(data.products)
                        );

                        if (!productUuid) {
                            const baseProduct = data.products.find((row: any) => !row.isAddOn) ?? data.products[0];
                            localStorage.setItem("productUuid", baseProduct.productUuid);
                            if (baseProduct.productVariantUuid) {
                                localStorage.setItem("productVariantUuid", baseProduct.productVariantUuid);
                            }
                            if (baseProduct.productBookingStartDate && baseProduct.productBookingEndDate) {
                                localStorage.setItem("bookingDate", JSON.stringify({
                                    startDate: floatingUtcToLocalDate(baseProduct.productBookingStartDate),
                                    endDate: floatingUtcToLocalDate(baseProduct.productBookingEndDate),
                                    rentPrice: baseProduct.productRentalValue,
                                }));
                            }
                            productDetailsClient
                                .getProductDetails({ productUuid: baseProduct.productUuid })
                                .then((productDetailsData: any) => {
                                    localStorage.setItem("storeUuid", productDetailsData.storeDetails.uuid);
                                    setIdvBypass(productDetailsData.storeDetails);
                                    setStoreDetails(productDetailsData.storeDetails);
                                })
                                .catch(() => { });
                        }
                    }
                }
            })
            .catch((error: any) => {
                toast.error(error.message);
                setError(error.message);
                setLoading(false);
            });
    };

    useEffect(() => {
        if (quoteId) {
            getQuoteData();
        }
    }, [quoteId]);

    const calculateTotalPrice = (subtotal: number) => {
        // const deliveryCharges = quote?.deliveryAndCollectionCharge;

        const deliveryCharges =
            (deliveryMethod === "Collect in Store"
                ? //  quote?.instoreCollectionCharge
                0 // Passing Dierectly 0 for now
                : deliveryMethod === "Delivery and Collection"
                    ? quote?.deliveryAndCollectionCharge
                    : 0) || 0;
        const serviceChargeValue = quote
            ? quote.serviceCharge + quote.totalDepositAmount
            : 0;
        const totalAmount: any =
            subtotal + serviceChargeValue + (deliveryCharges ?? 0);

        const totalAmountDeposite: any =
            subtotal +
            (Number(quote?.serviceCharge) ?? 0) +
            (Number(deliveryCharges) ?? 0);
        setTotalWithoutDeposite(Number(totalAmountDeposite).toFixed(2));
        setTotalAmount(Number(totalAmount).toFixed(2));
    };

    useEffect(() => {
        const subtotal = (parseFloat(quoteChargesForProceed?.orderValue) || 0);
        if (quote) {
            calculateTotalPrice(subtotal);
        }
    }, [deliveryMethod, data, quote]);

    if (loading) {
        <LoaderPage />;
    }

    if (error) {
        return <NotFound />;
    }
    if (!data) return <div>{t("no-product-details-found")}</div>;
    const handleDateSelect = (date: any) => {
        if (date) {
            setData(date);
        }
    };

    const updateProductQuantity = async (updatedData: any[]): Promise<void> => {
        const newProductList = updatedData.map((productData: any) => ({
            productUuid: productData.productUuid,
            productName: productData.productName,
            retailerUuid: productData?.retailerUuid,
            storeUuid: productData?.storeUuid,
            rentalDuration: productData?.rentalTerm,
            quantity: productData?.productQuantity,
            rentalType: quote?.rentalType,
            productVariantUuid: productData?.productVariantUuid,
            option1: productData?.option1,
            option2: productData?.option2,
            option3: productData?.option3,
            bookingDate: {
                bookingStartDate: productData?.productBookingStartDate,
                bookingEndDate: productData?.productBookingEndDate,
            },
            isAddOn: data?.find((row: any) => row.productVariantUuid === productData?.productVariantUuid)?.isAddOn ?? false,
            baseProductUuidForAddOn: data?.find((row: any) => row.isAddOn === false)?.productUuid ?? productData.productUuid,
            ...(quoteId && { previousQuoteUuid: quoteId }),
            productRetailValue: productData?.productRetailValue,
        }));

        try {
            // First, get the quote charges to check product availability
            const quoteCharges = await productDetailsClient.getQuotesCharges({
                products: newProductList,
            }) as QuoteChargesResponse;

            // Check if any product is not available
            if (!quoteCharges.productAvailibility) {
                // Find which products are not available
                const unavailableProducts = quoteCharges.productRates
                    .filter((rate: ProductRate) => !rate.updateQuoteProduct || rate.isProductAvailable === false)
                    .map((rate: ProductRate) => rate.productName);

                // Get the specific unavailable product names
                const specificUnavailable = quoteCharges.productRates
                    .filter((rate: ProductRate) => rate.isProductAvailable === false)
                    .map(rate => rate.productName);

                if (specificUnavailable.length > 0) {
                    throw new Error(`Requested quantity not available for: ${specificUnavailable.join(', ')}`);
                } else if (unavailableProducts.length > 0) {
                    throw new Error(`The following items cannot be updated: ${unavailableProducts.join(', ')}`);
                } else {
                    throw new Error('One or more products are not available for the selected dates');
                }
            }

            const productData = quoteCharges.productRates.map((proData: any) => ({
                productRentalTerm: proData.rentalTerm,
                productRate: proData.productRate,
                productDepositAmount: proData?.productDepositAmount,
                productQuantity: proData?.quantity || 1,
                productRentalPrice: proData?.productRentalValue,
                productRetailValue: proData?.productRetailValue,
                productUuid: proData?.productUuid,
                productName: "",
                bookingDate: newProductList[0]?.bookingDate || {},
                productVariantUuid: proData?.productVariantUuid,
                option1: proData?.option1,
                option2: proData?.option2,
                option3: proData?.option3,
                isAddOn: proData.isAddOn
            }));

            const mergedArray = productData.map((item1: any) => {
                const match = newProductList.find(
                    (item2: any) =>
                        item2.productUuid === item1.productUuid &&
                        item2.productVariantUuid === item1.productVariantUuid
                );
                return match
                    ? {
                        ...item1,
                        productName: match?.productName,
                        bookingDate: match?.bookingDate || {},
                    }
                    : item1;
            });

            const request = {
                products: mergedArray,
                quoteTotal: quoteCharges?.orderValue,
                depositAmount: quoteCharges?.depositCharge,
                serviceCharge: quoteCharges?.serviceCharge,
                deliveryCharge: quoteCharges?.deliveryCharge,
                instoreCollectionCharge: quoteCharges?.instoreCollectionCharge,
                storeUuid: quote?.storeUuid,
                rentalType: quote?.rentalType,
                retailerUuid: quote?.retailerUuid,
                rentalDuration: newProductList[0]?.rentalDuration
            };

            setLoading(true);
            const res = await productDetailsClient.createQuote(request) as CreateQuoteResponse;
            if (quote?.discountCode) {
                await productDetailsClient.applyPromoCode({
                    quoteUuid: res?.quote?.uuid,
                    discountCode: quote?.discountCode,
                });
            }

            if (quoteId) {
                await productDetailsClient.deleteQuote({ quoteUuid: quoteId });
            }

            setQuoteCookies(res.quote.uuid);
            setData(updatedData);
            setLoading(false);

        } catch (error: any) {
            setLoading(false);

            // Revert the quantity in the UI if the update fails
            const revertedData = data.map((item: any) => {
                const updatedItem = updatedData.find(
                    (updated: any) =>
                        updated.productUuid === item.productUuid &&
                        updated.productVariantUuid === item.productVariantUuid
                );
                if (updatedItem) {
                    return { ...item, productQuantity: item.productQuantity };
                }
                return item;
            });
            setData(revertedData);

            // Show appropriate error message
            toast.error(error?.message || "Failed to update quantity", {
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
        }
    };

    const increaseProductQuantity = async (productUuid: string, productVariantUuid?: string) => {
        const updatedData = data.map((item: any) => {
            if (item.productUuid === productUuid && item.productVariantUuid === productVariantUuid) {
                // Increase the productQuantity by 1
                return { ...item, productQuantity: (item.productQuantity || 1) + 1 };
            }
            return item;
        });

        await updateProductQuantity(updatedData);
    };

    const removeProduct = async (productUuid: string, productVariantUuid?: string) => {
        let singleProductQuantity = data[0].productQuantity;
        if (data.length > 1 || singleProductQuantity > 1) {
            const updatedData = data.reduce((result: any, item: any) => {
                // Check both productUuid and productVariantUuid (if provided)
                if (item.productUuid === productUuid &&
                    item.productVariantUuid === productVariantUuid) {
                    if (item.productQuantity > 1) {
                        // Reduce the productQuantity by 1
                        result.push({ ...item, productQuantity: item.productQuantity - 1 });
                    }
                    // If productQuantity is 1, the item is not added to the result
                } else {
                    // Keep items that don't match the productUuid or productVariantUuid
                    result.push(item);
                }
                return result;
            }, []);


            const newProductList = updatedData
                // .filter((u: any) => u.productUuid !== productUuid)
                .map((productData: any) => ({
                    productUuid: productData.productUuid,
                    productName: productData.productName,
                    retailerUuid: productData?.retailerUuid,
                    storeUuid: productData?.storeUuid,
                    rentalDuration: productData?.rentalTerm, // rental duration,
                    quantity: productData?.productQuantity,
                    rentalType: quote?.rentalType,
                    productVariantUuid: productData?.productVariantUuid,
                    option1: productData?.option1,
                    option2: productData?.option2,
                    option3: productData?.option3,
                    bookingDate: {
                        bookingStartDate: productData?.productBookingStartDate,
                        bookingEndDate: productData?.productBookingEndDate,
                    },
                    isAddOn: data?.find((row: any) => row.productVariantUuid === productData?.productVariantUuid)?.isAddOn ?? false,
                    baseProductUuidForAddOn: data?.find((row: any) => row.isAddOn === false)?.productUuid ?? productData.productUuid,
                    ...quoteId && { previousQuoteUuid: quoteId },
                }));
            // Check if newProductList is empty, if so, handle it properly
            if (newProductList.length === 0) {
                // If no products left, delete the quote entirely
                setLoading(true);
                await productDetailsClient
                    .deleteQuote({
                        quoteUuid: quoteId,
                    })
                    .then((response: any) => {

                        setLoading(false);
                        deleteCookie(QUOTE_SESSION);
                        setProductDelete(false);
                        localStorage.removeItem("card-item");
                        localStorage.removeItem("bookingDate");
                        toast.success("Item Delete Success !");
                        navigate(`/product/?id=${baseProductUuidForAddOn ?? productUuid}`);
                    })
                    .catch((err: any) => {
                        setLoading(false);
                        setProductDelete(false);
                        toast.error("Failed to delete item");
                    });
                return;
            }

            await productDetailsClient
                .getQuotesCharges({ products: newProductList })
                .then(async (response: any) => {
                    const productData = response.productRates.map(
                        (proData: any) => ({
                            productRentalTerm: proData.rentalTerm,
                            productRate: proData.productRate,
                            productDepositAmount: proData?.productDepositAmount,
                            productQuantity: proData?.quantity ? proData?.quantity : 1,
                            productRentalPrice: proData?.productRentalValue,
                            productRetailValue: proData?.productRetailValue,
                            productUuid: proData?.productUuid,
                            productName: "",
                            bookingDate: newProductList[0].bookingDate,
                            productVariantUuid: proData?.productVariantUuid,
                            option1: proData?.option1,
                            option2: proData?.option2,
                            option3: proData?.option3,
                            isAddOn: proData.isAddOn
                        })
                    );

                    const mergedArray = productData.map((item1: any) => {
                        const match = newProductList.find(
                            (item2: any) =>
                                item2.productUuid === item1.productUuid &&
                                item2.productVariantUuid === item1.productVariantUuid
                        );
                        return match
                            ? {
                                ...item1,
                                productName: match?.productName,
                                bookingDate: match?.bookingDate,
                            }
                            : item1;
                    });
                    const request = {
                        products: mergedArray,
                        quoteTotal: response?.orderValue,
                        depositAmount: response?.depositCharge,
                        serviceCharge: response?.serviceCharge,
                        // deliveryCharge: response?.response?.instoreCollectionCharge,
                        deliveryCharge: response?.deliveryCharge,
                        instoreCollectionCharge:
                            response?.instoreCollectionCharge,

                        storeUuid: quote?.storeUuid,
                        rentalType: quote?.rentalType,
                        retailerUuid: quote?.retailerUuid,
                        rentalDuration: newProductList[0]?.rentalDuration
                    };

                    setLoading(true);

                    await productDetailsClient
                        .createQuote(request)
                        .then(async (res: any) => {
                            if (quote?.discountCode) {
                                await productDetailsClient.applyPromoCode({
                                    quoteUuid: res?.quote?.uuid,
                                    discountCode: quote?.discountCode,
                                });
                            }
                            await productDetailsClient
                                .deleteQuote({
                                    quoteUuid: quoteId,
                                })
                                .then((response: any) => {
                                    setLoading(false);
                                })
                                .catch((err: any) => {
                                    setLoading(false);
                                });
                            setQuoteCookies(res.quote.uuid);
                            setProductDelete(false);

                            // navigate("/cart");
                        })
                        .catch((error: any) => {
                            setLoading(false);
                            toast.error(error?.message);
                            // setShowToast(true);
                            // setToastType("danger");
                        });
                })
                .catch((error) => {
                    setLoading(false);
                    toast.error(error?.message);
                    // setShowToast(true);
                    // setToastType("danger");
                });
        } else {
            setLoading(true);

            await productDetailsClient
                .deleteQuote({
                    quoteUuid: quoteId,
                })
                .then((response: any) => {

                    setLoading(false);

                    deleteCookie(QUOTE_SESSION);
                    setProductDelete(false);
                    localStorage.removeItem("card-item");
                    localStorage.removeItem("bookingDate");
                    toast.success("Item Delete Success !");
                    navigate(`/product/?id=${baseProductUuidForAddOn ?? productUuid}`);
                })
                .catch((err: any) => {
                    setLoading(false);

                    setProductDelete(false);
                });
        }

        // console.log("newProductCount:::::", newProductList);
        // productDetailsClient
        //   .deleteCustomerQuoteProduct({
        //     quoteUuid: quoteId,
        //     productUuid: productUuid,
        //   })
        //   .then((res: any) => {
        //     if (res) {
        //       const id = data.findIndex(
        //         (product: any) => product?.uuid === res.uuid
        //       );
        //       data.splice(id, 1);
        //       localStorage.setItem("card-item", data.length.toString());
        //       if (data.length === 0) {
        //         localStorage.removeItem("card-item");
        //         localStorage.removeItem("bookingDate");
        //       }
        //       setToastMessage(t("product-deleted"));
        //       setShowToast(true);
        //       setProductDelete(false);
        //       setDeletProductId("");
        //     }
        //   })
        //   .catch((error: any) => {
        //     setShowToast(true);
        //     setToastMessage(error?.message);
        //     setToastType("danger");
        //   });
    };

    const handleEditProduct = (details: any) => {
        setModalShow(true);
    };

    const placeOrder = async () => {
        // if (customerUuid) {
        //   // navigate('/information-capture');
        //   navigate('/verify-identity');
        // } else {
        // if (deliveryMethod === "Delivery and Collection") {

        const productData = quoteChargesForProceed.productRates.map((proData: any) => ({
            productRentalTerm: proData.rentalTerm,
            productRate: proData.productRate,
            productDepositAmount: proData?.productDepositAmount,
            productQuantity: proData?.quantity,
            productRentalPrice: proData?.productRentalValue,
            productRetailValue: proData?.productRetailValue,
            productUuid: proData?.productUuid,
            productName: proData?.productName,
            productVariantUuid: proData?.productVariantUuid,
            option1: proData?.option1,
            option2: proData?.option2,
            option3: proData?.option3,
            bookingDate: {
                bookingStartDate: data[0]?.productBookingStartDate,
                bookingEndDate: data[0]?.productBookingEndDate,
            },
            isAddOn: proData?.isAddOn
        }));

        let request;
        if (deliveryMethod === "Delivery and Collection") {
            request = {
                products: productData,
                quoteTotal: quoteCharges?.orderValue,
                depositAmount: quoteCharges?.depositCharge,
                serviceCharge: quoteCharges?.serviceCharge,
                deliveryCharge: quoteCharges?.deliveryCharge,
                productRetailPrice: quoteCharges?.productRetailPrice,
                instoreCollectionCharge: quoteCharges?.instoreCollectionCharge,
                storeUuid: quote?.storeUuid,
                rentalType: quote?.rentalType,
                retailerUuid: quote?.retailerUuid,
                rentalDuration: quote?.rentalDuration,
                isDeliveryRequired: true,
                deliveryMethod: "Delivery and Collection",
                deliveryAndCollectionCharge: quoteCharges?.deliveryCharge,
            };
        } else {
            request = {
                products: productData,
                quoteTotal: quoteCharges?.orderValue,
                depositAmount: quoteCharges?.depositCharge,
                serviceCharge: quoteCharges?.serviceCharge,
                productRetailPrice: quoteCharges?.productRetailPrice,
                deliveryCharge: quoteCharges?.instoreCollectionCharge, // Adding delivery charge as instore delivery charge for collect in store orders
                instoreCollectionCharge: quoteCharges?.instoreCollectionCharge,
                storeUuid: quote?.storeUuid,
                rentalType: quote?.rentalType,
                retailerUuid: quote?.retailerUuid,
                isDeliveryRequired: false,
                rentalDuration: quote?.rentalDuration,
                deliveryMethod: "Collect in Store",
                deliveryAndCollectionCharge:
                    quoteCharges?.instoreCollectionCharge,
            };
        }

        // const request = {
        //     products: productData,
        //     quoteTotal: quoteCharges?.orderValue,
        //     depositAmount: quoteCharges?.depositCharge,
        //     serviceCharge: quoteCharges?.serviceCharge,
        //     deliveryCharge: quoteCharges?.deliveryCharge,
        //     instoreCollectionCharge: quoteCharges?.instoreCollectionCharge,
        //     storeUuid: quote?.storeUuid,
        //     rentalType: quote?.rentalType,
        //     retailerUuid: quote?.retailerUuid,
        //     isDeliveryRequired: true,
        //     deliveryMethod: "Delivery and Collection",
        //     deliveryAndCollectionCharge: quoteCharges?.deliveryCharge,
        // };

        await productDetailsClient
            .createQuote(request)
            .then(async (res: any) => {
                // 
                if (quote?.discountCode) {
                    await productDetailsClient.applyPromoCode({
                        quoteUuid: res?.quote?.uuid,
                        discountCode: quote?.discountCode,
                    });
                }
                await productDetailsClient
                    .deleteQuote({
                        quoteUuid: quoteId,
                    })
                    .then((response: any) => {
                        setLoading(false);
                    })
                    .catch((err: any) => {
                        setLoading(false);
                    });
                setQuoteCookies(res.quote.uuid);
                navigate("/login");
            })
            .catch((error: any) => {
                setLoading(false);
                toast.error(error?.message);
            });
        // } else {
        //     navigate("/login");
        // }
        // }
        // const value = {
        //   orderAmount: totalAmount,
        //   depositAmount: charges?.depositCharge,
        //   serviceCharge: charges?.serviceCharge,
        //   rentalStartDate: quote?.rentalStartDate,
        //   rentalEndDate: quote?.rentalEndDate,
        //   deliveryMethod: deliveryMethod,
        //   deliveryAndCollectionCharge: deliveryMethod === 'Delivery and Collection' ? charges?.deliveryCharge : charges?.instoreCollectionCharge,
        //   ...(quoteId ? { existingQuoteUuid: quoteId } : {}),
        //   ...(customerUuid ? { customerUuid: customerUuid } : {}),
        // }
        // productDetailsClient.updateCustomerQuote(value)
        //   .then((data: any) => {
        //     setData(data.products);
        //     localStorage.removeItem('email');
        //     setToastMessage(t('oreder-sucessfully-places'))
        //     setToastType('sucess');
        //     setLoading(false);
        //     if (customerUuid) {
        //       // navigate('/information-capture');
        //       navigate('/verify-identity');
        //     } else {
        //       navigate('/login');
        //     }
        //   })
        //   .catch((error: any) => {
        //     setShowToast(true);
        //     setToastMessage(error?.message)
        //     setToastType('danger');
        //     setLoading(false);
        //   });
    };

    // Function to calculate total price of all orders
    // const calculateTotalPrice = (subtotal: number) => {
    //   const deliveryCharges =
    //     deliveryMethod === "Collect in Store"
    //       ? quote?.deliveryAndCollectionCharge
    //       : quote?.deliveryCharge;
    //   const serviceChargeValue = quote
    //     ? quote.serviceCharge + quote.totalDepositAmount
    //     : 0;
    //   const totalAmount: any =
    //     subtotal + serviceChargeValue + (deliveryCharges ?? 0);
    //   const totalAmountDeposite: any =
    //     subtotal + (quote?.serviceCharge ?? 0) + (deliveryCharges ?? 0);
    //   setTotalWithoutDeposite(totalAmountDeposite);
    //   setTotalAmount(totalAmount.toFixed(2));
    // };

    const handleOptionChange = (event: any) => {
        setDeliveryMethod(event.target.value);
    };
    const getQuoteCharges = (totalRate: any) => {
        productDetailsClient
            .getProductPricing({ productRentalPrice: totalRate })
            .then((data: any) => {
                setProductPricing(data);
                calculateTotalPrice(totalRate);
                setLoading(false);
            })
            .catch((error: any) => {
                setError(error.message);
                setLoading(false);
            });
    };

    const handleApplyPromocode = async () => {
        if (!promocodeInput.trim() || isApplyingPromocode || promocodeInput === lastAttemptedPromocode) return;
        setIsApplyingPromocode(true);
        setDiscountError(false);
        setLastAttemptedPromocode(promocodeInput);
        try {
            await productDetailsClient.applyPromoCode({
                quoteUuid: quoteId,
                discountCode: promocodeInput,
            });
            toast.success("Discount code applied successfully");
            setPromocodeInput("");
            setLastAttemptedPromocode("");
            await getQuoteData(true);
        } catch (error: any) {
            setDiscountError(true);
        } finally {
            setIsApplyingPromocode(false);
        }
    };

    const handleRemovePromocode = async () => {
        try {
            await productDetailsClient.removePromoCode({
                quoteUuid: quoteId,
            });
            toast.success("Discount code removed");
            setAppliedPromocode(null);
            setPromocodeInput("");
            setDiscountError(false);
            setOpenDiscountSection(true);
            await getQuoteData(true);
        } catch (error: any) {
            toast.error("Failed to remove promocode");
        }
    };
    return (
        <>
            {loading ? (
                <LoaderPage />
            ) : (
                <>
                    <section className="cart-section section-space">
                        <div className="container">
                            <div className="row">
                                <div className="offset-xxl-0 col-xxl-8 offset-xl-0 col-xl-7 offset-md-1 col-md-10">
                                    {/*  */}
                                    <div
                                        className={`cart-product-date ${data.length >= 3
                                            ? "space-bottom"
                                            : ""
                                            }`}
                                    >
                                        <h4 className="estimated-date">
                                            {t("estimated-dates")}
                                            <OverlayTrigger
                                                placement="auto"
                                                overlay={
                                                    <Tooltip
                                                        id={`tooltip-e-date`}
                                                        style={{
                                                            position: "fixed",
                                                        }}
                                                    >
                                                        {t(
                                                            "estimated-dates-tooltip"
                                                        )}
                                                    </Tooltip>
                                                }
                                                popperConfig={{
                                                    modifiers: [
                                                        {
                                                            name: "preventOverflow",
                                                            options: {
                                                                boundary:
                                                                    "window", // Ensure the tooltip stays within the window boundary
                                                            },
                                                        },
                                                        {
                                                            name: "flip",
                                                            options: {
                                                                fallbackPlacements:
                                                                    [
                                                                        "top",
                                                                        "bottom",
                                                                        "left",
                                                                        "right",
                                                                    ], // Provide fallback placements
                                                            },
                                                        },
                                                    ],
                                                }}
                                            >
                                                <Info className="info-icon" />
                                            </OverlayTrigger>
                                        </h4>
                                        {/* {data?.map((item: any, index: number) => ( */}
                                        <div className="selected-date">
                                            <div className="selected-date-box">
                                                <h5 className="product-date">
                                                    {/* Hourly Base */}
                                                    {isSameDate(
                                                        data[0]
                                                            ?.productBookingStartDate,
                                                        data[0]
                                                            ?.productBookingEndDate
                                                    ) && quote?.rentalType == 'hourly' ? (
                                                        <DateTimeDisplay
                                                            startDateTime={
                                                                data[0]
                                                                    ?.productBookingStartDate
                                                            }
                                                            endDateTime={
                                                                data[0]
                                                                    ?.productBookingEndDate
                                                            }
                                                        />
                                                    ) : (
                                                        <>
                                                            {quote?.rentalType ===
                                                                "monthly-recurring" ? (
                                                                // Combine the formatted and 'Monthly Rolling'
                                                                `${moment(
                                                                    data[0]
                                                                        ?.productBookingStartDate
                                                                ).format(
                                                                    "DD MMMM"
                                                                )} – ${t(
                                                                    "monthly-rolling"
                                                                )}`
                                                            ) : quote?.rentalType ===
                                                                "daily" ? (
                                                                <FormattedDateRange
                                                                    startDate={
                                                                        data[0]
                                                                            ?.productBookingStartDate
                                                                    }
                                                                    endDate={
                                                                        moment(data[0]?.productBookingStartDate)
                                                                            .add(parseInt(data[0]?.rentalTerm) - 1, 'days')
                                                                            .toISOString()
                                                                    }
                                                                />
                                                            ) : (
                                                                // For other rental types, just display the formatted date
                                                                <FormattedDateRange
                                                                    startDate={
                                                                        data[0]
                                                                            ?.productBookingStartDate
                                                                    }
                                                                    endDate={
                                                                        data[0]
                                                                            ?.productBookingEndDate
                                                                    }
                                                                />
                                                            )}
                                                        </>
                                                    )}
                                                </h5>
                                                {isSameDate(
                                                    data[0]
                                                        ?.productBookingStartDate,
                                                    data[0]
                                                        ?.productBookingEndDate
                                                ) ? (
                                                    <span className="date-duration">
                                                        {t("duration")} :{" "}
                                                        {calculateDuration(
                                                            data[0]
                                                                ?.productBookingStartDate,
                                                            data[0]
                                                                ?.productBookingEndDate,
                                                            quote?.rentalType,
                                                            data[0]?.rentalTerm
                                                        )}
                                                    </span>
                                                ) : (
                                                    <span className="date-duration">
                                                        {t("duration")} :{" "}
                                                        {quote?.rentalType ===
                                                            "monthly-recurring"
                                                            ? t("flexible")
                                                            : data[0]
                                                                ?.rentalTerm}{" "}
                                                        {quote?.rentalType ===
                                                            "monthly"
                                                            ? data[0]
                                                                ?.rentalTerm >
                                                                1
                                                                ? t("months")
                                                                : t("month")
                                                            : ""}
                                                        {quote?.rentalType ===
                                                            "daily"
                                                            ? data[0]
                                                                ?.rentalTerm >
                                                                1
                                                                ? t("days")
                                                                : t("day")
                                                            : ""}
                                                    </span>
                                                )}
                                            </div>
                                            <Link
                                                to={"#"}
                                                onClick={() =>
                                                    handleEditProduct(data)
                                                }
                                            >
                                                <Edit className="ms-3 edit-icon" />
                                            </Link>
                                        </div>
                                        {/* ))} */}
                                    </div>
                                    {/*  */}
                                    <div className="cart-product-section product-box-section">
                                        <div className="cart-product-title">
                                            <h4>{t("products-details")}</h4>
                                            <h4>{t("total")}</h4>
                                        </div>
                                        {/* {data.length >= 0 ? (
                                            <h5 className="total-product">
                                                {t("total-product")} :{" "}
                                                {data.length}
                                            </h5>
                                        ) : (
                                            ""
                                        )} */}
                                        <div
                                            className={`cart-product-details-boxs ${data.length >= 3
                                                ? "md-height custom-scroll res-space"
                                                : ""
                                                }`}
                                        >
                                            {productData?.map(
                                                (item: any, index: number) => {
                                                    return (
                                                        <div key={item.uuid} className="cart-product-details">
                                                            <div className="d-flex align-items-center justify-content-between mb-1">
                                                                <Link
                                                                    to={`/product/?id=${item.productUuid}`}
                                                                    className="c-product-title"
                                                                >
                                                                    {item.productName}
                                                                </Link>
                                                                <div className="quantity-controls">
                                                                    <div className="d-flex align-items-center gap-2">
                                                                        <>
                                                                            {item.quantity > 1 ? (
                                                                                <button
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        removeProduct(item.productUuid, item.productVariantUuid);
                                                                                    }}
                                                                                    className="quantity-btn minus-btn"
                                                                                    aria-label="Remove one item"
                                                                                >
                                                                                    -
                                                                                </button>
                                                                            ) : (
                                                                                <button
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        setProductDelete(true);
                                                                                        setDeletProductId(item.productUuid);
                                                                                        setDeleteVariantId(item.productVariantUuid);
                                                                                    }}
                                                                                    className="quantity-btn delete-btn"
                                                                                    aria-label="Remove item"
                                                                                >
                                                                                    <Trash2 size={14} />
                                                                                </button>
                                                                            )}
                                                                            <span className="quantity-number">{item.quantity || 1}</span>
                                                                            <button
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    increaseProductQuantity(item.productUuid, item.productVariantUuid);
                                                                                }}
                                                                                className="quantity-btn plus-btn"
                                                                                aria-label="Add one more"
                                                                            >
                                                                                +
                                                                            </button>

                                                                        </>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Display variant options if they exist */}
                                                            <div className="variant-options">
                                                                {(item.option1 || item.option2 || item.option3) && (
                                                                    <p className="variant-option">
                                                                        {item.option1 && (
                                                                            <span className="option  fw-semibold">
                                                                                <span className="option-label fw-normal">{item.option1.split(': ')[0]} :</span> {item.option1.split(': ')[1]}
                                                                            </span>
                                                                        )}
                                                                        {item.option2 && (
                                                                            <span className="option fw-semibold">
                                                                                <span className="option-label fw-normal">{item.option2.split(': ')[0]} :</span> {item.option2.split(': ')[1]}
                                                                            </span>
                                                                        )}
                                                                        {item.option3 && (
                                                                            <span className="option fw-semibold">
                                                                                <span className="option-label fw-normal">{item.option3.split(': ')[0]} :</span> {item.option3.split(': ')[1]}
                                                                            </span>
                                                                        )}
                                                                    </p>
                                                                )}
                                                            </div>

                                                            <h5 className="product-price monthly-product-price">
                                                                £{(
                                                                    Number(item.productRentalValue) * (item.quantity || 1)
                                                                ).toFixed(2)}
                                                            </h5>

                                                            {item?.isProductDeliverable &&
                                                                !item?.isCollectFromStoreEnabled && (
                                                                    <p className="delivery-status">
                                                                        <DeliveryTruck className="collect-img delivery-t delivery-t-icon" />
                                                                        {"    "}{" "}
                                                                        Delivery
                                                                        Available
                                                                    </p>
                                                                )}
                                                            {item?.isCollectFromStoreEnabled &&
                                                                !item?.isProductDeliverable && (
                                                                    <p className="delivery-status">
                                                                        <CollectStore className="collect-img instore-t-icon" />
                                                                        {"    "}
                                                                        Collect from
                                                                        Store
                                                                    </p>
                                                                )}
                                                            {item?.isCollectFromStoreEnabled &&
                                                                item?.isProductDeliverable && (
                                                                    <p className="delivery-status">
                                                                        <CollectStore className="collect-img instore-t-icon" />
                                                                        {"    "}
                                                                        Collect from
                                                                        Store or
                                                                        Delivery
                                                                        Available
                                                                    </p>
                                                                )}

                                                        </div>
                                                    );
                                                }
                                            )}
                                        </div>
                                        {/* Scan to add more product */}
                                        {/* <div className="add-new-product">
                                            <Link
                                                to={"/scanner"}
                                                className="add-product"
                                            >
                                                {t("scan-to-add-more-product")}
                                                <PlusCircle className="ms-2" />
                                            </Link>
                                        </div> */}
                                    </div>
                                    <div className="add-more-product mt-3" onClick={(event) => {
                                        event.preventDefault();
                                        navigate('/shop');
                                    }}>
                                        <div className="store-icon">
                                            <img src="./images/shop.svg"></img>
                                        </div>
                                        <div className="shop-text">
                                            Click here to add more products
                                            <p>
                                                From {storeDetails?.storeName}
                                            </p>
                                        </div>

                                        <span>
                                            <ChevronRight size={16}></ChevronRight>
                                            <ChevronRight size={16} className="second-arrow"></ChevronRight>
                                        </span>
                                    </div>
                                </div>
                                {/*  */}
                                {/*  */}



                                <div className="offset-xxl-0 col-xxl-4 offset-xl-0 col-xl-5 offset-md-1 col-md-10">

                                    <div className="order-summary-position">
                                        {/* className="cart-chnages-page" */}
                                        <div className="effect-add-section cart-page-effect">
                                            <Effect className="effect-img" />
                                            {/*  */}
                                            <div className="cart-product-section delivery-section">
                                                <div className="cart-product-title order-summary">
                                                    <h4>
                                                        {t("order-summary")}
                                                    </h4>
                                                </div>

                                                <div className="delivery-method">
                                                    {/* Delivery method title */}

                                                    <div className="select-method">
                                                        {!loading &&
                                                            !quoteCharges?.deliveryMessage &&
                                                            !quoteCharges?.productDelivery &&
                                                            !quoteCharges?.productInStoreCollection ? (
                                                            <p className="fulfilment-text">
                                                                To continue all
                                                                of the products
                                                                in your basket
                                                                must have the
                                                                same fulfilment
                                                                option
                                                                available.
                                                                Please update
                                                                your basket.
                                                            </p>
                                                        ) : (
                                                            <>
                                                                <h4>
                                                                    {t(
                                                                        "select-delivery-method"
                                                                    )}
                                                                </h4>
                                                                {!hideCollectFromStore && (
                                                                    <div className="cart-value">
                                                                        <Form.Check
                                                                            id={`collect-in-store`}
                                                                            className="delivery-method-radio"
                                                                            type={
                                                                                "radio"
                                                                            }
                                                                            name="shipping-method"
                                                                            value="Collect in Store"
                                                                            checked={
                                                                                deliveryMethod ===
                                                                                "Collect in Store"
                                                                            }
                                                                            onChange={
                                                                                handleOptionChange
                                                                            }
                                                                            label={
                                                                                <div className="d-flex justify-content-between">
                                                                                    <label
                                                                                        htmlFor={`collect-in-store`}
                                                                                        className="form-check-label"
                                                                                    >
                                                                                        {t(
                                                                                            "collect-in-store"
                                                                                        )}
                                                                                    </label>
                                                                                    <h5 className="product-price">
                                                                                        £
                                                                                        {Number(
                                                                                            quote?.instoreCollectionCharge ??
                                                                                            0
                                                                                        ).toFixed(
                                                                                            2
                                                                                        )}
                                                                                    </h5>
                                                                                </div>
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                                {quote?.rentalType !==
                                                                    "hourly" && (
                                                                        <div className="cart-value">
                                                                            <Form.Check
                                                                                disabled={
                                                                                    !quoteCharges?.productDelivery
                                                                                }
                                                                                id="delivery-and-collection"
                                                                                className="delivery-method-radio"
                                                                                type={
                                                                                    "radio"
                                                                                }
                                                                                name="shipping-method"
                                                                                value="Delivery and Collection"
                                                                                checked={
                                                                                    deliveryMethod ===
                                                                                    "Delivery and Collection"
                                                                                }
                                                                                onChange={
                                                                                    handleOptionChange
                                                                                }
                                                                                label={
                                                                                    <>
                                                                                        <div className="d-flex justify-content-between">
                                                                                            <label
                                                                                                htmlFor="delivery-and-collection"
                                                                                                className="form-check-label"
                                                                                            >
                                                                                                {t(
                                                                                                    "delivery-and-collection"
                                                                                                )}
                                                                                                <OverlayTrigger
                                                                                                    placement="bottom"
                                                                                                    overlay={
                                                                                                        <Tooltip id={`tooltip-dc`}>
                                                                                                            {t("delivery-and-collection-tooltip")}
                                                                                                        </Tooltip>
                                                                                                    }
                                                                                                >
                                                                                                    <Info className="info-icon ms-2" size={18} />
                                                                                                </OverlayTrigger>
                                                                                            </label>

                                                                                            <h5 className="product-price">
                                                                                                £
                                                                                                {Number(
                                                                                                    quote?.deliveryAndCollectionCharge ??
                                                                                                    0
                                                                                                ).toFixed(
                                                                                                    2
                                                                                                )}
                                                                                            </h5>
                                                                                        </div>
                                                                                        {quoteCharges?.deliveryMessage && (
                                                                                            <span className="hint-message">
                                                                                                {
                                                                                                    quoteCharges?.deliveryMessage
                                                                                                }
                                                                                            </span>
                                                                                        )}
                                                                                    </>
                                                                                }
                                                                            />
                                                                        </div>
                                                                    )}
                                                            </>
                                                        )}

                                                        <div className="cart-value divider-top">
                                                            {!quote?.canConvertedToPurchaseAfterRent && (
                                                                <>
                                                                    <h5 className="cart-title">
                                                                        Renticy{" "}
                                                                        {t(
                                                                            "renticy-service-charge"
                                                                        )}
                                                                        <OverlayTrigger
                                                                            placement="bottom"
                                                                            overlay={
                                                                                <Tooltip
                                                                                    id={`tooltip-service`}
                                                                                    style={{
                                                                                        position:
                                                                                            "fixed",
                                                                                    }}
                                                                                >
                                                                                    <div dangerouslySetInnerHTML={{ __html: t("renticy-service-charge-tooltip") }} />
                                                                                </Tooltip>
                                                                            }
                                                                        >
                                                                            <Info
                                                                                className="info-icon ms-2"
                                                                                size={
                                                                                    18
                                                                                }
                                                                            />
                                                                        </OverlayTrigger>
                                                                    </h5>
                                                                    <h5 className="product-price d-flex monthly-product-price">
                                                                        £
                                                                        {Number(
                                                                            quote?.serviceCharge ??
                                                                            0
                                                                        ).toFixed(2)}
                                                                        {
                                                                            quote?.rentalType === "monthly" &&
                                                                            <> <span>per month</span></>
                                                                        }
                                                                    </h5>
                                                                </>
                                                            )}
                                                        </div>
                                                        {quote?.discountAmount && quote?.discountAmount > 0 && <div className="cart-value">
                                                            <h5 className="cart-title">
                                                                Discount Applied
                                                            </h5>
                                                            <h5 className="product-price d-flex monthly-product-price">
                                                                - £{Number(quote?.discountAmount).toFixed(2)}
                                                            </h5>
                                                        </div>}
                                                        <div className="cart-value total-cart">
                                                            <h5 className="cart-title">
                                                                {quote?.canConvertedToPurchaseAfterRent ? t("total-trial-to-pay-today") : t("total-rental-to-pay-today")}
                                                            </h5>
                                                            <h5 className="product-price cart-price">
                                                                £
                                                                {Number(
                                                                    quote?.totalQuoteValue
                                                                ).toFixed(2)}
                                                            </h5>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            {/* Promo Code Section */}
                                            {<div className="cart-product-section promocode-section">
                                                {(!loading && openDiscountSection || quote?.discountCode) ?
                                                    <>
                                                        {!appliedPromocode ? (
                                                            (
                                                                <div className="promocode-input-wrapper">
                                                                    <div className="promocode-header">
                                                                        <h5>Add Discount code</h5>
                                                                    </div>
                                                                    <div className="promocode-input-group">
                                                                        <input
                                                                            type="text"
                                                                            className="promocode-input"
                                                                            placeholder="Enter discount code"
                                                                            value={
                                                                                promocodeInput
                                                                            }
                                                                            onChange={(e) => {
                                                                                setPromocodeInput(e.target.value);
                                                                                setLastAttemptedPromocode("");
                                                                            }}
                                                                            onKeyPress={(e) => {
                                                                                if (e.key === "Enter") {
                                                                                    handleApplyPromocode();
                                                                                }
                                                                            }}
                                                                        />
                                                                        <button
                                                                            className="promocode-apply-btn"
                                                                            onClick={
                                                                                handleApplyPromocode
                                                                            }
                                                                            disabled={
                                                                                !promocodeInput.trim() || isApplyingPromocode || promocodeInput === lastAttemptedPromocode
                                                                            }
                                                                        >
                                                                            {isApplyingPromocode ? "Applying..." : "Apply"}
                                                                        </button>
                                                                    </div>
                                                                    {discountError && (
                                                                        <div className="promocode-error">Invalid Discount Code</div>
                                                                    )}
                                                                </div>
                                                            )
                                                        ) : (
                                                            <div className="promocode-applied-wrapper">
                                                                <div className="promocode-applied-header">
                                                                    <div className="applied-status">
                                                                        <span className="checkmark">✓</span>
                                                                        <span>Discount code Applied</span>
                                                                    </div>
                                                                    <span
                                                                        className="promocode-remove-btn"
                                                                        onClick={
                                                                            handleRemovePromocode
                                                                        }
                                                                    >
                                                                        Remove
                                                                    </span>
                                                                </div>
                                                                <div className="promo-code-display">{appliedPromocode}</div>
                                                            </div>
                                                        )}
                                                    </>
                                                    : quote?.showAddDiscountButton && (
                                                        <span
                                                            className="promocode-btn"
                                                            onClick={() => setOpenDiscountSection(true)}
                                                        >
                                                            Apply Discount Code +
                                                        </span>
                                                    )
                                                }

                                            </div>}
                                            {/*  */}
                                            <div className="cart-product-section refundable-deposit">
                                                <div className="refundable-title">
                                                    <DepositIcon className="me-2 mb-1 img-fluid info-icon" />
                                                    <h5 className="cart-title">
                                                        {t(
                                                            "refundable-deposit"
                                                        )}
                                                        <span>
                                                            {t("what-is-this")}
                                                            <OverlayTrigger
                                                                placement="bottom"
                                                                overlay={
                                                                    <Tooltip
                                                                        id={`tooltip-rd`}
                                                                        style={{
                                                                            position:
                                                                                "fixed",
                                                                        }}
                                                                    >
                                                                        {t(
                                                                            "refundable-deposit-tooltip"
                                                                        )}
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <Info
                                                                    className="info-icon ms-1"
                                                                    size={18}
                                                                />
                                                            </OverlayTrigger>
                                                        </span>
                                                    </h5>
                                                </div>
                                                <h5 className="product-price cart-price">
                                                    £
                                                    {Number(
                                                        quote?.totalDepositAmount ??
                                                        0
                                                    ).toFixed(2)}
                                                </h5>
                                            </div>

                                            {quote?.canConvertedToPurchaseAfterRent && (
                                                <div className="ownit-box d-flex align-items-center justify-content-between mt-3">
                                                    <div>
                                                        <div className="ownit-text-black">OWN<span>it</span></div>
                                                        <label
                                                            htmlFor="optional-price-after-trial"
                                                            className="form-check-label"
                                                        >
                                                            {t("optional-price-after-trial")}
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={
                                                                    <Tooltip id={`tooltip-op`}>
                                                                        <div dangerouslySetInnerHTML={{ __html: t("optional-price-after-trial-tooltip") }} />
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <Info className="info-icon ms-2" size={18} />
                                                            </OverlayTrigger>
                                                        </label>
                                                    </div>
                                                    <div className="ownit-price-text text-end">
                                                        <div className="ownit-price">£{quote?.ownItPricing?.purchasePrice?.toFixed(2)}</div>
                                                        <div><span className="fw-bold">{quote?.ownItPricing?.discountPercentage}% off</span> retail price​</div>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="place-order-btn">
                                                <div className="cart-details">
                                                    {isSameDate(
                                                        data[0]
                                                            ?.productBookingStartDate,
                                                        data[0]
                                                            ?.productBookingEndDate
                                                    ) && quote?.rentalType == 'hourly' ? (
                                                        <DateTimeDisplay
                                                            startDateTime={
                                                                data[0]
                                                                    ?.productBookingStartDate
                                                            }
                                                            endDateTime={
                                                                data[0]
                                                                    ?.productBookingEndDate
                                                            }
                                                        />
                                                    ) : (
                                                        <>
                                                            {quote?.rentalType ===
                                                                "monthly-recurring" ? (
                                                                // Combine the formatted and 'Monthly Rolling'
                                                                `${moment(
                                                                    data[0]
                                                                        ?.productBookingStartDate
                                                                ).format(
                                                                    "DD MMMM"
                                                                )} – ${t(
                                                                    "monthly-rolling"
                                                                )}`
                                                            ) : quote?.rentalType ===
                                                                "daily" ? (
                                                                <FormattedDateRange
                                                                    startDate={
                                                                        data[0]
                                                                            ?.productBookingStartDate
                                                                    }
                                                                    endDate={
                                                                        moment(data[0]?.productBookingStartDate)
                                                                            .add(parseInt(data[0]?.rentalTerm) - 1, 'days')
                                                                            .toISOString()
                                                                    }
                                                                />
                                                            ) : (
                                                                // For other rental types, just display the formatted date
                                                                <FormattedDateRange
                                                                    startDate={
                                                                        data[0]
                                                                            ?.productBookingStartDate
                                                                    }
                                                                    endDate={
                                                                        data[0]
                                                                            ?.productBookingEndDate
                                                                    }
                                                                />
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                                {/* disabled={data.length === 0 || !deliveryMethod} */}
                                                <Button
                                                    btnText="Continue"
                                                    onClick={placeOrder}
                                                    disabled={
                                                        data.length === 0 ||
                                                        !deliveryMethod
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* Calender Modal Show */}
                    <CalendarModal
                        show={modalShow}
                        onDateSelect={handleDateSelect}
                        onHide={() => setModalShow(false)}
                        details={{
                            ...quote,
                            ...productDetailsByUUID,
                            edit: true,
                            productDetails: data,
                            productDetailsByUUID: productDetailsByUUID,
                            productUuid: data.map((u: any) => u.productUuid),
                            storeDetails: storeDetails
                        }}
                        productpricing={productPricing}
                        commonProductPricing={commonProductPricing}
                        getQuoteData={getQuoteData}
                        productVariantUuid={productVariantUuid}
                    />
                    {/* Delete Product Start */}
                    <NotificationModal
                        show={productDelete}
                        notificationHide={() => {
                            setProductDelete(false);
                            setDeletProductId("");
                            setDeleteVariantId("");
                        }}
                        notificationOk={() => removeProduct(deletProductId, deleteVariantId)}
                        notificationtitle={t("delete-item")}
                        notificationtext={t("delete-item-message")}
                    />
                    {/* Delete Product End */}
                    {/* <ToastMessage
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
        type={toastType}
      /> */}
                    {/* Cookies Modal */}
                    <SiteCookiesModal
                        show={cookiesModalShow}
                        cookiesHide={() => setCookiesModalShow(false)}
                        onAccept={() => handleCookieConsent("isAccepted")}
                        onReject={() => handleCookieConsent("rejected")}
                        onSettings={() => handleCookieConsent("settings")}
                    />
                </>
            )}
        </>
    );
};

export default ProductCart;
